"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const logoStyles_1 = __importDefault(require("./logoStyles"));
const logoLendigo = require('../../assets/images/Lendigo-Logo-Name.png');
const Logo = ({ fixedSize = false }) => {
    const screenWidth = react_native_1.Dimensions.get('window').width;
    let container = react_1.default.createElement(react_native_1.Image, { source: logoLendigo, style: [logoStyles_1.default.logo, { width: 126 }] });
    if (screenWidth >= 800 || fixedSize) {
        container = react_1.default.createElement(react_native_1.Image, { source: logoLendigo, style: [logoStyles_1.default.logo, { width: 180 }] });
    }
    return container;
};
exports.default = Logo;
